import { IApplicationState } from '../../types/redux';

export const selectCpdLandingSaleUrl = (state: IApplicationState): string | null => {
  const isAvailable = state.cpd.isAvailable;

  if (!isAvailable) {
    return null;
  }

  return state.cpd.cpdLandingSaleUrl;
};

export const selectCpdLandingSaleToBuyUrl = (state: IApplicationState): string | null => {
  const isAvailable = state.cpd.isAvailable;

  if (!isAvailable) {
    return null;
  }

  return state.cpd.cpdLandingSaleToBuyUrl;
};

export const selectCpdLandingBuyUrl = (state: IApplicationState): string | null => {
  const isAvailable = state.cpd.isAvailable;

  if (!isAvailable) {
    return null;
  }

  return state.cpd.cpdLandingBuyUrl;
};
